import HomeComponent from "./pages/Home";

function App(){
  return (
    <HomeComponent />
  )
}

export default App;